export default __webpack_public_path__ + "static/media/edit.70ca0b7a.svg";